
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mypage/orders",
      function () {
        return require("private-next-pages/mypage/orders/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mypage/orders"])
      });
    }
  